<script setup lang="ts"></script>

<template>
   <div>
      <slot>
         <NuxtPage />
      </slot>
   </div>
</template>

<style scoped></style>
